"use strict";var e={rules:{"es-CO":{zipcode:{len:5,textLen:"Debe contener 5 dígitos"}}}};exports.default=e;